import { Component } from '@angular/core';
import { UserMessageService } from './user-message.service';

@Component({
	selector: 'user-message-component',
	templateUrl: 'user-message.component.html',
	styleUrls: [ 'user-message.component.css' ]
})

export class UserMessageComponent {
	userMessageService: UserMessageService;
	messageLog: any[];

	constructor(userMessageService: UserMessageService) {
		this.userMessageService = userMessageService;

		/* This didn't work because the messages were released prior to the creation of this component.
		** Using userMessageService.userMessages instead.
		**
		this.userMessageService.userMessageObserver.subscribe ((message) => {
			this.log += ( message + "\n");
		}, this);
		*/

		this.getUserMessages();
	}

	getUserMessages () {
		/*let messages = this.userMessageService.userMessages;
		messages.forEach(function(item){
			//this.messageLog += ('\u2714' + item + "\u000A");
			this.messageLog += ("<p>" + item + "<br>");
		}, this);
		*/
		// console.log(this.userMessageService.userMessages)
		this.messageLog = this.userMessageService.userMessages;
	}
}
